<template>
  <div class="flight-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "flightBase",
};
</script>
